/* eslint-disable */
import React, {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import 'contents/assets/scss/page/accounting.scss';
//component
import PopSelectSubject from './_PopSelectSubject.js'; //과목선택
import PopFeeManageCard from './_PopFeeManageCard'; //카드사별 수수료 관리
import Tab from '../../component/Inc/Tab';
function AccountingSubject() {
  const [modalSubject, setSubject] = useState(false);
  const [modalFeeManageCard, setFeeManageCard] = useState(false);
  const navigate = useNavigate();
  const [tabIdx, setTabIdx] = useState(0);
  const [tab2Idx, setTab2Idx] = useState(0);
  const tab01 = [
    {title: '국어', value: 0},
    {title: '영어', value: 1},
    {title: '수학', value: 2},
    {title: '사탐', value: 3},
    {title: '과탐', value: 4},
    {title: '논술', value: 5},
    {title: '면접', value: 6},
    {title: '생디', value: 7}
  ];
  const tab02 = [
    {title: '전체', value: 0},
    {title: '미확인', value: 1},
    {title: '일치', value: 2},
    {title: '불일치', value: 3},
    {title: '입금위치 모름', type: 'red', value: 4}
  ];
  return (
    <main className="com_container">
      <div className="com_center_wrap p_accounting_subject">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu8_2 active">과목별 입금 관리</h2>
          <div className="com_btn_wrap">
            <button className="com_btn orange s btn_settings" onClick={() => setFeeManageCard(true)}>
              카드사 별 수수료 관리
            </button>
            <button className="com_btn orange s btn_plus">입금내역 추가</button>
          </div>
        </section>
        <section className="com_pg_container">
          <div className="box full">
            <div className="com_board_list__top">
              <div className="board_select">
                <select className="select">
                  <option value="이지수능 (본사)">이지수능 (본사)</option>
                </select>
                <Tab data={tab01} tab={tabIdx} setTab={setTabIdx} tabStyle="fit_cont" />
              </div>
              <section className="com_board_search end">
                <article className="search">
                  <input type="search" placeholder="검색할 내용을 입력해 주세요." className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
            </div>
            <hr className="com_divider" />
            <div className="com_board_list__top">
              <Tab data={tab02} tab={tab2Idx} setTab={setTab2Idx} tabStyle="fit_cont" />
              <section className="com_board_search">
                <div className="com_btn_wrap">
                  <button className="com_btn line gray s active">오늘</button>
                  <button className="com_btn line gray s">주간</button>
                  <button className="com_btn line gray s">월간</button>
                </div>
                <div className="date_wrap">
                  <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                  <span className="divider"> ~ </span>
                  <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                  <button className="com_btn gray s">조회</button>
                </div>
              </section>
            </div>
            <hr className="com_divider" />
            <div className="com_board_list__top">
              <div className="check">
                <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
                <label htmlFor="rdo01">전체</label>
                <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
                <label htmlFor="rdo02">카드</label>
                <input type="radio" name="rdo" id="rdo03" className="com_chk circle" />
                <label htmlFor="rdo03">가상계좌</label>
                <input type="radio" name="rdo" id="rdo04" className="com_chk circle" />
                <label htmlFor="rdo04">현금</label>
              </div>
              <div className="com_count_wrapper">
                <div className="operators">
                  <div className="operators_label">
                    <span className="operators_count">총 입금 건수</span>
                    <span className="operators_value">98건</span>
                  </div>
                </div>
                <div className="turnover">
                  <div className="turnover_label">
                    <span className="turnover_count">총 입금액</span>
                    <span className="turnover_value">46,500,000</span>
                  </div>
                </div>
              </div>
            </div>
            <table className="com_board_list">
              <colgroup>
                <col width="50" />
                <col width="100" />
                <col width="85" />
                <col width="90" />
                <col width="70" />
                <col width="100" />
                <col width="110" />
                <col width="85" />
                <col width="85" />
                <col width="70" />
                <col width="70" />
                <col width="150" />
                <col width="100" />
                <col width="70" />
                <col width="70" />
                <col width="70" />
                <col width="70" />
              </colgroup>
              <thead>
                <tr>
                  <th>No.</th>
                  <th>입금일</th>
                  <th>학생명</th>
                  <th>과목</th>
                  <th>회차 / T</th>
                  <th>할인</th>
                  <th>상품가격</th>
                  <th>교사</th>
                  <th>담임</th>
                  <th>입금자</th>
                  <th>입금방법</th>
                  <th>입금방법</th>
                  <th>입금회차 /금액</th>
                  <th>수수료</th>
                  <th>승인번호</th>
                  <th>비고</th>
                  <th>보기</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1</td>
                  <td>2022, 08, 25</td>
                  <td>
                    <button className="btn_link">홍학생123</button>
                  </td>
                  <td>수학</td>
                  <td>16회 / 2T</td>
                  <td>형제할인 2%</td>
                  <td>46,650,000</td>
                  <td>
                    <button className="btn_link">김교사103</button>
                  </td>
                  <td>
                    <button className="btn_link">김담임103</button>
                  </td>
                  <td>김길동</td>
                  <td>카드</td>
                  <td>[국민]6546-645-*****-645</td>
                  <td className="td_point">3회/ 300,000</td>
                  <td>45,000</td>
                  <td className="td_point">1324</td>
                  <td className="com_red_txt">미확인</td>
                  <td className="td_point">
                    <button className="txt btn_link" onClick={() => navigate('/Accounting/Subject/Detail')}>
                      보기
                    </button>
                  </td>
                </tr>
                <tr>
                  <td>1</td>
                  <td>2022, 08, 25</td>
                  <td>
                    <button className="btn_link">홍학생123</button>
                  </td>
                  <td className="td_red has_btn_edit">
                    모름<button className="btn_edit" onClick={() => setSubject(true)}></button>
                  </td>
                  <td>16회 / 2T</td>
                  <td>형제할인 2%</td>
                  <td>46,650,000</td>
                  <td>
                    <button className="btn_link">김교사103</button>
                  </td>
                  <td>
                    <button className="btn_link">김담임103</button>
                  </td>
                  <td>김길동</td>
                  <td>카드</td>
                  <td>[국민]6546-645-*****-645</td>
                  <td className="td_point">3회/ 300,000</td>
                  <td>45,000</td>
                  <td className="td_point">1324</td>
                  <td className="com_red_txt">미확인</td>
                  <td className="td_point">
                    <button className="txt btn_link" onClick={() => navigate('/Accounting/Subject/Detail')}>
                      보기
                    </button>
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td className="bg_col"></td>
                  <td className="bg_col"></td>
                  <td className="bg_col"></td>
                  <td className="bg_col"></td>
                  <td className="bg_col"></td>
                  <td className="bg_col"></td>
                  <td className="bg_col td_point">660,665,000</td>
                  <td className="bg_col"></td>
                  <td className="bg_col"></td>
                  <td className="bg_col"></td>
                  <td className="bg_col"></td>
                  <td className="bg_col"></td>
                  <td className="bg_col td_point">321,646,684</td>
                  <td className="bg_col">45,000</td>
                  <td className="bg_col td_point"></td>
                  <td className="bg_col"></td>
                  <td className="bg_col"></td>
                </tr>
              </tfoot>
            </table>
          </div>
        </section>
      </div>
      <PopSelectSubject open={modalSubject} close={() => setSubject(false)} />
      <PopFeeManageCard open={modalFeeManageCard} close={() => setFeeManageCard(false)} />
    </main>
  );
}

export default AccountingSubject;
